<template>
  <IconButton bgColor="#F17901" width="9.8em" :svg="$assets.svg.register_icon" @click="click">
    Register Now
  </IconButton>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import $assets from '@/assets';
import IconButton from '@/components/event/IconButton.vue';
import ZoomService from '@/services/zoom';
import useMessagesStore from '@/stores/messages';
import useSessionStore from '@/stores/session';
import Logger from '@/utils/logger';

const props = defineProps({
  evEventOrCourse: {
    type: Object,
    default: () => ({}),
  },
});

const $router = useRouter();
const MessagesStore = useMessagesStore();
const SessionStore = useSessionStore();

const loginUser = computed(() => {
  return SessionStore.loginUser;
});

const isProfessionalEvent = computed(() => {
  return props.evEventOrCourse.type_code === 'PROFESSIONAL';
});

async function click() {
  if (isProfessionalEvent.value) {
    $router.push({
      name: 'course',
      params: { eventId: props.evEventOrCourse.id },
    });
    return;
  }

  const webinarId = props.evEventOrCourse.webinar_id;
  const isMeeting = props.evEventOrCourse.is_meeting;

  // eslint-disable-next-line no-unused-vars
  const payload = {
    webinarId,
    isMeeting,
    firstName: loginUser.value.firstName,
    lastName: loginUser.value.lastName,
    userId: loginUser.value.id,
    userEmail: loginUser.value.email,
  };

  try {
    const response = await ZoomService.getRegistrants(webinarId);
    Logger.debug(response);

    if (response.records.length >= props.evEventOrCourse.max_registrants) {
      MessagesStore.createRegistrationFull();
    } else {
      const success = await ZoomService.createRegistrant(payload);
      MessagesStore.createMessage(success);
    }
  } catch (error) {
    Logger.debug(error);
    MessagesStore.createError(error);
  }
}
</script>
